//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from "vue-multiselect";

export default {
  props: {
    bgColor: String,
  },
  name: "ContactForm",
  components: {
    Multiselect,
  },
  data() {
    return {
      fullPath: this.$route.fullPath,
      form: {
        name: null,
        phone: null,
        email: '',
        message: '',
        medicalReports: [],
        fullsrc: null,
        services: "",
        isTermsAccepted: false,
      },

      images: [{path: ""}, {path: ""}, {path: ""}, {path: ""}],
      files: [],
      treatmentList: [
        {
          slug: "dental-treatments",
          treatmentType: this.$t("popup.dentalTreatment"),
        },
        {
          slug: "hair-transplant",
          treatmentType: this.$t("popup.hairTransplant"),
        },
        {
          slug: "obesity",
          treatmentType: this.$t("popup.obesitySurgery"),
        },
        {
          slug: "vision-correction-surgery",
          treatmentType: this.$t("popup.visionCorrection"),
        },
        {
          slug: "health-resorts",
          treatmentType: this.$t("popup.healthResorts"),
        },
        {
          slug: "other-medical-services",
          treatmentType: this.$t("popup.otherServices"),
        },
      ],
    };
  },
  mounted() {
    this.form.fullsrc = `https://www.ilajak.com${this.$route.fullPath}`;
    // if (this.$route.path.includes('resorts')) {
    //   this.form.services = 'health-resorts'
    // }
  },
  methods: {
    choosePhone(phone) {
      this.form.phone = phone.formattedNumber;
    },
    validatePhoneNumber(phoneNumber) {
      const phoneRegex = /^(\+\d{1,2})?\d{8,}$/;
      return phoneRegex.test(phoneNumber);
    },

    async contactFormSend() {
      if (!this.form.isTermsAccepted) {
        this.$toast.error(this.$i18n.t('acceptTerms'))
        return
      }
      else if (!(this.validatePhoneNumber(this.form.phone))) {
        this.$toast.error(this.$i18n.t('contactForm.wrongPhoneFormat'))
        return
      }
      //if there is files selected
      else if (this.files.length > 0) {
        try {
          let fd = new FormData();
          for (let index = 0; index < this.files.length; index++) {
            fd.append(`medicalReports[]`, this.files[index]);
          }
          fd.append("name", this.form.name);
          fd.append("phone", this.form.phone);
          fd.append("email", this.form.email);
          fd.append("message", this.form.message);
          fd.append("fullsrc", this.form.fullsrc);
          fd.append(
            "services",
            this.form.services.slug
              ? this.form.services.slug
              : "undefined-request"
          );
          this.$toast.info(this.$t("contactForm.sending"), {
            duration: 100000,
          });
          await this.$api.contactFormSend(fd).then((resp) => {
            if (resp.status === 200 || resp.status === 204) {
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({event: "form_submitted"});
              // console.log("we are here " + resp.status)
              console.log('form');

              this.$toast.success(resp.message);
              this.form.name = null;
              this.form.phone = null;
              this.form.message = null;
              this.form.email = null;
              this.form.services = "";
              this.form.medicalReports = [];
              this.images = [
                {path: ""},
                {path: ""},
                {path: ""},
                {path: ""},
              ];
            }
          });
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      }
      // if no files selected
      else {
        try {
          this.$toast.info(this.$t("contactForm.sending"), {
            duration: 100000,
          });
          // console.log({
          //   'name': this.form.name,
          //   'phone': this.form.phone,
          //   'message': this.form.message,
          //   //send 'undefined-request' if the user didn't choose a service
          //   'services': this.form.services.slug ? this.form.services.slug : 'undefined-request',
          //   'email': this.form.email,
          //   'fullsrc': this.form.fullsrc,
          // });
          await this.$api
            .contactFormSend({
              name: this.form.name,
              phone: this.form.phone,
              message: this.form.message,
              //send 'undefined-request' if the user didn't choose a service
              services: this.form.services.slug
                ? this.form.services.slug
                : "undefined-request",
              email: this.form.email,
              fullsrc: this.form.fullsrc,
            })
            .then((resp) => {
              if (resp.status === 200 || resp.status === 204) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({event: "form_submitted"});
                // console.log("we are here " + resp.status)
                this.$toast.success(resp.message);
                this.form.name = null;
                this.form.phone = null;
                this.form.message = null;
                this.form.email = null;
                this.form.services = "";
                this.form.medicalReports = [];
                this.images = [
                  {path: ""},
                  {path: ""},
                  {path: ""},
                  {path: ""},
                ];
              }
            });
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      }
    },

    async previewFiles(event, index) {
      let file = event.target.files[0];
      const fileSize = Math.round(file.size / 1024);
      if (fileSize <= 2 * 1024) {
        const imageFormat = /\.(jpe?g|png)$/i;
        const docxFile = /\.(docx|doc)$/i;
        const pdfFile = /\.pdf$/i;
        if (file.name.match(imageFormat)) {
          this.images[index - 1].path = URL.createObjectURL(file);
          this.files.push(file);
        } else if (file.name.match(docxFile)) {
          this.images[index - 1].path = "/images/doc-icon.png";
          this.files.push(file);
        } else if (file.name.match(pdfFile)) {
          this.images[index - 1].path = "/images/pdf-icon.png";
          this.files.push(file);
        } else {
          this.$toast.error(this.$t("contactForm.supportedFiles"));
          //empty file after if it's not supported
          file = null;
          // this.images[index - 1].path = '/images/unsupportedFile.png'
        }
      } else {
        this.$toast.error(this.$t("contactForm.fileSizeError"));
        file = null;
      }
      //check if the file is image or not for the preview
    },
  },
};
